// Jemná animácia pri scrollovaní (Framer Motion).
// Obalí ľubovoľný obsah: <Reveal><h2>...</h2></Reveal>

import React from 'react';
import { motion } from 'framer-motion';

export default function Reveal({ children, delay = 0, y = 24, className = '' }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6, delay, ease: [0.25, 0.1, 0.25, 1] }}
    >
      {children}
    </motion.div>
  );
}
